import React from 'react';
import { buildImageUrl } from '@teetsh/app/src/utils/urls';

interface Props {
  alt: string;
  fileUrl: string;
  className?: string;
  maxWidth?: string;
  maxHeight?: string;
}

export function PreviewImg(props: Props) {
  const { alt, fileUrl, maxWidth, maxHeight } = props;
  return (
    <img
      alt={alt}
      className={props.className}
      src={buildImageUrl(fileUrl, 'imagekit', { width: 340 })}
      style={{
        maxWidth: maxWidth || '170px',
        maxHeight: maxHeight || '100px',
      }}
    />
  );
}
